@for (step of steps; track i; let i = $index) {
  <span [class.active]="step"></span>
}
